import type { ApiConfig, FetchApiData, FetchSubTypes } from '../types'
import { depositHistoryApiConfig } from './depositHistory/constants'
import { fetchApiData as fetchDepositHistoryApiData } from './depositHistory/fetchApiData'
import { spotTradeHistoryApiConfig } from './spotTradeHistory/constants'
import { fetchApiData as fetchSpotTradeHistoryApiData } from './spotTradeHistory/fetchApiData'
import { fetchSubTypes as fetchSpotTradeHistorySubTypes } from './spotTradeHistory/fetchSubTypes'
import { withdrawalHistoryApiConfig } from './withdrawalHistory/constants'
import { fetchApiData as fetchWithdrawalHistoryApiData } from './withdrawalHistory/fetchApiData'

export const mexcApiConfigs = {
  [depositHistoryApiConfig.type]: depositHistoryApiConfig,
  [spotTradeHistoryApiConfig.type]: spotTradeHistoryApiConfig,
  [withdrawalHistoryApiConfig.type]: withdrawalHistoryApiConfig,
} as const satisfies Record<string, ApiConfig>

export type MexcApiType = keyof typeof mexcApiConfigs

export const mexcApiTypes = Object.keys(mexcApiConfigs) as MexcApiType[]

export const fetchMexcApiDataFuncs = {
  [depositHistoryApiConfig.type]: fetchDepositHistoryApiData,
  [spotTradeHistoryApiConfig.type]: fetchSpotTradeHistoryApiData,
  [withdrawalHistoryApiConfig.type]: fetchWithdrawalHistoryApiData,
} as const satisfies Record<string, FetchApiData>

export const fetchMexcSubTypesFuncs = {
  [depositHistoryApiConfig.type]: undefined,
  [spotTradeHistoryApiConfig.type]: fetchSpotTradeHistorySubTypes,
  [withdrawalHistoryApiConfig.type]: undefined,
} as const satisfies Record<string, FetchSubTypes | undefined>

export { getCurrentMexcAssets } from './getCurrentAsset'
